export default {
    'language': '芬兰',
}
;
